import { createSlice } from "@reduxjs/toolkit";
import type { FieldsState, FieldsStateActionTypes } from "../types/fieldsState.types";
import { FIELDS_STATE_SLICE_NAME } from "../utils/storeUtils";

const initialState: FieldsState = {
  reportType: null,
};

const fieldsStateSlice = createSlice({
  name: FIELDS_STATE_SLICE_NAME,
  initialState,
  reducers: {
    setReportType: (state, action: FieldsStateActionTypes["setReportType"]) => {
      state.reportType = action.payload;
    },
  },
});

export default fieldsStateSlice.reducer;
